import React from "react";
import styled from "styled-components";
// Assets
import AppDevelopmentSvg from "../../assets/svg/Services/AppDevelopment";
import AiSvg from "../../assets/svg/Services/ArtificialIntelligence ";
import CloudInfrastructureSvg from "../../assets/svg/Services/CloudInfrastructure";
import WebsiteDevelopmentSvg from "../../assets/svg/Services/WebsiteDevelopment";
import BlockchainSvg from "../../assets/svg/Services/BlockchainTechnology";

export default function ServiceBox({ icon, title, subtitle }) {
  let getIcon;

  switch (icon) {
    case "websiteDevelopment":
      getIcon = <WebsiteDevelopmentSvg />;
      break;
    case "cloudInfrastructure":
      getIcon = <CloudInfrastructureSvg />;
      break;
    case "appDevelopment":
      getIcon = <AppDevelopmentSvg />;
      break;
    case "artificialIntelligence":
      getIcon = <AiSvg />;
      break;
    case "blockchainTechnology":
      getIcon = <BlockchainSvg />;
      break;
    default:
      getIcon = <WebsiteDevelopmentSvg />;
      break;
  }


  return (
    <Wrapper className="flex flexColumn">
      <IconStyle>{getIcon}</IconStyle>
      <TitleStyle className="font20 extraBold animated-gradient-text">{title}</TitleStyle>
      <SubtitleStyle className="font13">{subtitle}</SubtitleStyle>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
`;
const IconStyle = styled.div`
  @media (max-width: 860px) {
    margin: 0 auto;
  }
`;
const TitleStyle = styled.h2`
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
  padding: 40px 0;
  @media (max-width: 860px) {
    padding: 20px 0;
  }
`;
const SubtitleStyle = styled.p`
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
`;